import { useEffect } from "react";
import { useBrandLoaderData } from "../../root/rootLoader.ts";
import { useCurrentFullLocale } from "../../../common/utils/locale.ts";

const CookieCat = () => {
  const brand = useBrandLoaderData();
  const locale = useCurrentFullLocale();
  useEffect(() => {
    if (brand.Cookies.notify) {
      window.CookieCat?.init?.({
        app: "dewey",
        theme: brand.Theme.primary,
        locale: locale,
      });
    }
  }, [brand, locale]);

  return null;
};

export default CookieCat;
